export const AUTH_TOKEN_KEY = "userstokentoken";
export const AUTH_EMAIL_KEY = "email";
export const AUTH_USERID_KEY = "userId";
